import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/home/Home.vue")
  },
  {
    path: "/articles/:articleId",
    component: () => import("@/views/article/Article.vue")
  },
  {
    path: "/archives",
    component: () => import("@/views/archive/Archive.vue"),
    meta: {
      title: "归档"
    }
  },
  {
    path: "/albums",
    component: () => import("@/views/album/Album.vue"),
    meta: {
      title: "相册"
    }
  },
  {
    path: "/albums/:albumId",
    component: () => import("@/views/album/Photo.vue")
  },
  {
    path: "/tags",
    component: () => import("@/views/tag/Tag.vue"),
    meta: {
      title: "标签"
    }
  },
  {
    path: "/categories",
    component: () => import("@/views/category/Category.vue"),
    meta: {
      title: "分类"
    }
  },
  {
    path: "/categories/:categoryId",
    component: () => import("@/views/article/ArticleList.vue")
  },
  {
    path: "/tags/:tagId",
    component: () => import("@/views/article/ArticleList.vue")
  },
  {
    path: "/links",
    component: () => import("@/views/link/Link.vue"),
    meta: {
      title: "友链列表"
    }
  },
  {
    path: "/about",
    component: () => import("@/views/about/About.vue"),
    meta: {
      title: "关于我"
    }
  },
  {
    path: "/message",
    component: () => import("@/views/message/Message.vue"),
    meta: {
      title: "留言板"
    }
  },
  {
    path: "/user",
    component: () => import("@/views/user/User.vue"),
    meta: {
      title: "个人中心"
    }
  },
  {
    path: "/callback/qq",
    component: () => import("@/components/OauthLogin.vue")
  },
  {
    path: "/callback/gitee",
    component: () => import("@/components/OauthLogin.vue")
  },
  {
    path: "/callback/weibo",
    component: () => import("@/components/OauthLogin.vue")
  },
  {
    path: "/questions",
    component: () => import("@/views/question/Question.vue")
  },
  {
    path: "/questions/:qCategoryId/:questionId",
    component: () => import("@/views/question/Question.vue")
  },
  {
    path: "/questions-app",
    component: () => import("@/views/question/Question-app.vue")
  },
  {
    path: "/questions-app/:qCategoryId/:questionId",
    component: () => import("@/views/question/Question-app.vue")
  },
  {
    path: "/favoriteQuestions",
    component: () => import("@/views/question/FavoriteQuestion.vue")
  },
  {
    path: "/favoriteQuestions-app",
    component: () => import("@/views/question/FavoriteQuestion-app.vue")
  },
  // 访问意料之外的路由时重定向到/personal
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_ROUTER,
  routes
});

export default router;
